import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import awsConfig from './aws-exports';
import { Amplify, Auth } from 'aws-amplify';


const isLocalhost = Boolean(
  window.location.hostname === "localhost" ||
  // [::1] is the IPv6 localhost address.
  window.location.hostname === "[::1]" ||
  // 127.0.0.1/8 is considered localhost for IPv4.
  window.location.hostname.match(
    /^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/
  ) ||
  window.location.hostname.match(
    /^192(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/
  )
);

// Assuming you have two redirect URIs, and the first is for localhost and second is for production
const [
  localRedirectSignIn,
  productionRedirectSignIn,
] = awsConfig.oauth.redirectSignIn.split(",");

const [
  localRedirectSignOut,
  productionRedirectSignOut,
] = awsConfig.oauth.redirectSignOut.split(",");

const updatedAwsConfig = {
  ...awsConfig,
  oauth: {
    ...awsConfig.oauth,
    redirectSignIn: isLocalhost ? localRedirectSignIn : productionRedirectSignIn,
    redirectSignOut: isLocalhost ? localRedirectSignOut : productionRedirectSignOut,
  },
  Storage: {
    AWSS3: {

      bucket: environment.DEPLOY_BUCKET, //REQUIRED -  Amazon S3 bucket name
      region: environment.REGION, //OPTIONAL -  Amazon service region

    }
  },
  Auth: {

    identityPoolId: environment.IDENTITY_POOL_ID, //REQUIRED - Amazon Cognito Identity Pool ID
    region: environment.REGION, // REQUIRED - Amazon Cognito Region
    userPoolId: environment.USERPOLL_ID, //OPTIONAL - Amazon Cognito User Pool ID
    userPoolWebClientId: environment.USERPOLL_WEBCLIENT, //OPTIONAL - Amazon Cognito Web Client ID

  },
}


Amplify.configure(updatedAwsConfig);
Auth.configure(updatedAwsConfig);

const triggerSpinner = () => {
  window.addEventListener('load', (e) => {
    document.getElementById('spinner-main').style.display = 'none'
  })
}

triggerSpinner();

if (environment.production) {
  enableProdMode();
}
if (window.top != window.self) {
  top.location.href = document.location.href;
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));

